import {
  actionTypes,
  ActionTypes,
  ScansSetFilterParamsAction,
  ScansFetchListSuccessAction,
  ScansFilterParamsResetAction,
  ScansFetchListByEmployeeSuccessAction
} from './actions';

import { Scan } from 'src/lib/interfaces/Scan.interface'
import { ScansByEmployee } from 'src/lib/interfaces/ScansByEmployee.interface'
import { BaseReportFilterParameters } from 'src/lib/interfaces/BaseReportFilterParameters.interface'

const moment = require('moment')

const initialFilterParams: BaseReportFilterParameters = {
  fromDate: moment().format('YYYY-MM-DD')
}

export interface ScansState {
  readonly scans?: Scan[]
  readonly isFetchingScans: boolean
  readonly scansByEmployee?: ScansByEmployee[]
  readonly filterParams: BaseReportFilterParameters
}

export const initialState: ScansState = {
  scans: undefined,
  isFetchingScans: false,
  filterParams: initialFilterParams
}

export function reducer(state: ScansState = initialState, action: ActionTypes): ScansState {
  switch (action.type) {
    case actionTypes.SCANS_FETCH_LIST:
      return {
        ...state,
        isFetchingScans: true
      }

    case actionTypes.SCANS_FETCH_LIST_FAILED:
      return {
        ...state,
        isFetchingScans: false
      }

    case actionTypes.SCANS_FETCH_LIST_SUCCESS:
      return {
        ...state,
        isFetchingScans: false,
        scans: (action as ScansFetchListSuccessAction).payload.scans
      }

    case actionTypes.SCANS_FETCH_LIST_BY_EMPLOYEE:
      return {
        ...state,
        isFetchingScans: true
      }

    case actionTypes.SCANS_FETCH_LIST_BY_EMPLOYEE_FAILED:
      return {
        ...state,
        isFetchingScans: false
      }

    case actionTypes.SCANS_FETCH_LIST_BY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        isFetchingScans: false,
        scansByEmployee: (action as ScansFetchListByEmployeeSuccessAction).payload.scans
      }

    case actionTypes.SCANS_FILTER_PARAMS_RESET: {
      const resetAction = action as ScansFilterParamsResetAction

      const filterParams = resetAction.payload.filterParams
      return {
        ...state,
        filterParams: {
          ...initialFilterParams,
          ...(filterParams || {})
        }
      }
    }
    case actionTypes.SCANS_SET_FILTER_PARAMS: {
      const filterParams = {
        ...state.filterParams,
        ...(action as ScansSetFilterParamsAction).payload.filterParams
      }

      return {
        ...state,
        filterParams
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/scans/reducer.ts